import { OrthoFlight } from "@nova/protobuf"
import {
    getFlightpathKMLFromImages,
    getOrthoArcKml,
    getOrthoArcTargetUrl,
    getOrthoTakTiffKey,
    getOrthoTileUrl,
} from "./util"
import { ProjectWithMetadata } from "@nova/constants"
import { finished, outputFolder, rgbImagePath } from "@nova/util-s3"

export const orthoFlightTransformer = (flight: OrthoFlight, project: ProjectWithMetadata) => {
    return {
        flightPathKML: () => getFlightpathKMLFromImages(flight, false),
        orthoArcTargetUrl: () => getOrthoArcTargetUrl(flight, project),
        orthoArcKml: (resourceUrl: string) => getOrthoArcKml(flight, resourceUrl),
        orthoTakTiffKey: () => getOrthoTakTiffKey(flight, project, "orthoDem"),
        entity: flight,
        tileUrl: (opacity = 1) => getOrthoTileUrl(flight, project, opacity),
        project,
        imagePath: (id: string) => rgbImagePath(project.orgId, project.id, flight.id, id),
        orthoTiff: () => finished(outputFolder(project.orgId, project.id, flight.id)),
        orthoKmz: () => finished(outputFolder(project.orgId, project.id, flight.id), "kmz"),
        orthoLowResTiff: () =>
            finished(outputFolder(project.orgId, project.id, flight.id), "tif", true),
    }
}
